(() => {
  const initialise = (root) => {
    if (root.dataset.fw27Ready) return;
    root.dataset.fw27Ready = 'true';
    if (window.location.hash === '#ProductFitGuide') root.querySelector('#ProductFitGuide')?.setAttribute('open', '');
    const motionAllowed = () => !matchMedia('(prefers-reduced-motion: reduce)').matches;
    const viewPriority = (element) => {
      const key = element.dataset.fw27Panel || element.dataset.fw27View || '';
      if (key === 'front') return 1;
      if (key === 'back') return 2;
      if (element.dataset.fw27MediaType === 'model') return 3;
      if (key === 'female') return 4;
      if (key === 'male') return 5;
      if (key === 'film') return 6;
      return 7;
    };
    const panels = [...root.querySelectorAll('[data-fw27-panel]')].sort((a, b) => viewPriority(a) - viewPriority(b));
    const viewButtons = [...root.querySelectorAll('[data-fw27-view]')].sort((a, b) => viewPriority(a) - viewPriority(b));
    const thumbnailRow = root.querySelector('.fw27-product__thumbnails');
    viewButtons.forEach((button) => thumbnailRow?.append(button));
    const stage = root.querySelector('[data-fw27-stage]');
    const mediaError = root.querySelector('[data-fw27-media-error]');
    const galleryStatus = root.querySelector('[data-fw27-gallery-status]');
    const zoomButton = root.querySelector('[data-fw27-zoom]');
    const lightbox = root.querySelector('[data-fw27-lightbox]');
    const lightboxImage = lightbox?.querySelector('img');
    const lightboxViewport = lightbox?.querySelector('[data-fw27-lightbox-viewport]');
    const magnify = lightbox?.querySelector('[data-fw27-magnify]');
    const activePanel = () => panels.find((panel) => !panel.hidden);
    const activeImage = () => activePanel()?.querySelector('img');
    const panelLabel = (panel) => viewButtons.find((button) => button.dataset.fw27View === panel?.dataset.fw27Panel)?.lastElementChild?.textContent.trim() || activeImage()?.alt || '';
    let tiltFrame;
    const resetTilt = () => {
      cancelAnimationFrame(tiltFrame);
      stage?.style.removeProperty('--tilt-x');
      stage?.style.removeProperty('--tilt-y');
    };
    const updateZoom = () => {
      const image = activeImage();
      const failed = Boolean(image?.complete && image.naturalWidth === 0);
      if (zoomButton) zoomButton.hidden = !image || failed;
      if (stage) stage.setAttribute('aria-busy', String(Boolean(image && !image.complete)));
      if (mediaError) mediaError.hidden = !failed;
    };
    panels.forEach((panel) => panel.querySelectorAll('img').forEach((image) => {
      image.addEventListener('load', () => { if (!panel.hidden) updateZoom(); });
      image.addEventListener('error', () => { if (!panel.hidden) updateZoom(); });
      image.draggable = false;
    }));
    const activate = (key) => {
      const next = panels.find((panel) => panel.dataset.fw27Panel === key);
      if (!next) return;
      const previous = activePanel();
      const direction = panels.indexOf(next) >= panels.indexOf(previous) ? 1 : -1;
      resetTilt();
      panels.forEach((panel) => {
        const selected = panel === next;
        panel.hidden = !selected;
        if (!selected) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
          panel.querySelectorAll('model-viewer').forEach((viewer) => viewer.pause?.());
          panel.querySelectorAll('iframe').forEach((frame) => {
            if (!frame.dataset.fw27OriginalSrc) frame.dataset.fw27OriginalSrc = frame.src;
            if (frame.getAttribute('src')) frame.removeAttribute('src');
          });
        } else {
          if (panel !== previous && motionAllowed() && panel.animate) {
            panel.getAnimations().forEach((animation) => animation.cancel());
            panel.animate([{ opacity: .3, transform: `translateX(${direction * 12}px)` }, { opacity: 1, transform: 'translateX(0)' }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
          }
          panel.querySelectorAll('iframe').forEach((frame) => {
            if (!frame.getAttribute('src') && frame.dataset.fw27OriginalSrc) frame.src = frame.dataset.fw27OriginalSrc;
          });
        }
      });
      viewButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.fw27View === key)));
      if (galleryStatus) galleryStatus.textContent = `${String(panels.indexOf(next) + 1).padStart(2, '0')} / ${String(panels.length).padStart(2, '0')} — ${panelLabel(next)}`;
      updateZoom();
    };
    const move = (amount, focus = false) => {
      if (panels.length < 2) return;
      const next = panels[(panels.indexOf(activePanel()) + amount + panels.length) % panels.length];
      activate(next.dataset.fw27Panel);
      if (focus) viewButtons.find((button) => button.dataset.fw27View === next.dataset.fw27Panel)?.focus();
    };
    viewButtons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.fw27View));
      button.addEventListener('keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1, true); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); const next = event.key === 'Home' ? viewButtons[0] : viewButtons.at(-1); activate(next.dataset.fw27View); next.focus(); }
      });
    });
    root.querySelectorAll('[data-fw27-step]').forEach((button) => button.addEventListener('click', () => move(Number(button.dataset.fw27Step))));
    const toolbar = root.querySelector('[data-fw27-gallery-toolbar]');
    if (toolbar) toolbar.hidden = panels.length < 2;
    let swipe;
    stage?.addEventListener('pointerdown', (event) => {
      swipe = event.pointerType === 'touch' && event.isPrimary && event.target.matches('img') ? { x: event.clientX, y: event.clientY, key: activePanel()?.dataset.fw27Panel } : null;
    }, { passive: true });
    stage?.addEventListener('pointerup', (event) => {
      if (!swipe) return;
      const dx = event.clientX - swipe.x;
      const dy = event.clientY - swipe.y;
      if (swipe.key === activePanel()?.dataset.fw27Panel && Math.abs(dx) > 64 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
      swipe = null;
    }, { passive: true });
    stage?.addEventListener('pointercancel', () => { swipe = null; }, { passive: true });
    stage?.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse' || !motionAllowed() || !activePanel()?.classList.contains('fw27-product__panel--cutout')) return;
      cancelAnimationFrame(tiltFrame);
      tiltFrame = requestAnimationFrame(() => {
        const bounds = stage.getBoundingClientRect();
        stage.style.setProperty('--tilt-x', `${((event.clientY - bounds.top) / bounds.height - .5) * -5}deg`);
        stage.style.setProperty('--tilt-y', `${((event.clientX - bounds.left) / bounds.width - .5) * 5}deg`);
      });
    }, { passive: true });
    stage?.addEventListener('pointerleave', resetTilt, { passive: true });
    const resetMagnification = () => {
      lightboxViewport?.classList.remove('is-magnified');
      magnify?.setAttribute('aria-pressed', 'false');
      if (magnify) magnify.textContent = '＋';
      if (lightboxViewport) { lightboxViewport.scrollTop = 0; lightboxViewport.scrollLeft = 0; }
    };
    const syncLightbox = () => {
      const image = activeImage();
      if (!image || !lightboxImage) return;
      resetMagnification();
      lightboxImage.src = image.dataset.zoomSrc || image.currentSrc || image.src;
      lightboxImage.alt = image.alt;
      const label = lightbox?.querySelector('[data-fw27-lightbox-label]');
      if (label) label.textContent = panelLabel(activePanel());
    };
    zoomButton?.addEventListener('click', () => {
      if (!activeImage() || !lightboxImage || !lightbox || typeof lightbox.showModal !== 'function') return;
      resetTilt();
      syncLightbox();
      lightbox.showModal();
      document.documentElement.classList.add('media-zoom-open');
    });
    lightbox?.querySelector('[data-fw27-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('close', () => {
      document.documentElement.classList.remove('media-zoom-open');
      resetMagnification();
      zoomButton?.focus({ preventScroll: true });
    });
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
    const moveLightbox = (amount) => {
      const images = panels.filter((panel) => panel.querySelector('img'));
      if (images.length < 2) return;
      const next = images[(images.indexOf(activePanel()) + amount + images.length) % images.length];
      activate(next.dataset.fw27Panel);
      syncLightbox();
    };
    lightbox?.querySelectorAll('[data-fw27-lightbox-step]').forEach((button) => {
      button.hidden = panels.filter((panel) => panel.querySelector('img')).length < 2;
      button.addEventListener('click', () => moveLightbox(Number(button.dataset.fw27LightboxStep)));
    });
    lightbox?.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey || lightboxViewport?.classList.contains('is-magnified')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); moveLightbox(event.key === 'ArrowRight' ? 1 : -1); }
    });
    magnify?.addEventListener('click', () => {
      const enlarged = lightboxViewport?.classList.toggle('is-magnified');
      magnify.setAttribute('aria-pressed', String(Boolean(enlarged)));
      magnify.textContent = enlarged ? '−' : '＋';
    });
    root.querySelectorAll('[data-fw27-play]').forEach((button) => {
      const video = button.closest('[data-fw27-panel]')?.querySelector('video');
      if (!video) return;
      button.addEventListener('click', async () => {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        stage?.setAttribute('aria-busy', 'true');
        try { await video.play(); } catch { button.textContent = root.dataset.playError || 'Unable to play. Try again.'; stage?.setAttribute('aria-busy', 'false'); }
        finally { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
      ['canplay', 'playing', 'loadeddata', 'error'].forEach((name) => video.addEventListener(name, () => stage?.setAttribute('aria-busy', 'false')));
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
    });
    if (activePanel()) activate(activePanel().dataset.fw27Panel);
    const variantsNode = root.querySelector('[data-fw27-variants]');
    if (!variantsNode) return;
    let variants;
    try { variants = JSON.parse(variantsNode.textContent); } catch { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    const select = root.querySelector('[data-fw27-variant-select]');
    const groups = [...root.querySelectorAll('[data-fw27-option-index]')];
    const quantity = root.querySelector('[data-fw27-quantity]');
    const submit = root.querySelector('[data-fw27-submit]');
    const buyNow = root.querySelector('[data-fw27-buy-now]');
    const form = root.querySelector('[data-fw27-form]');
    const quantitySteps = [...root.querySelectorAll('[data-fw27-quantity-step]')];
    const updateQuantitySteps = () => {
      quantitySteps.forEach((button) => {
        const amount = Number(button.dataset.fw27QuantityStep);
        button.disabled = Boolean(form?.getAttribute('aria-busy') === 'true' || submit?.disabled || (amount < 0 ? Number(quantity?.value) <= 1 : quantity?.hasAttribute('max') && Number(quantity.value) >= Number(quantity.max)));
      });
    };
    quantitySteps.forEach((button) => {
      button.hidden = false;
      button.addEventListener('click', () => {
        if (!quantity || button.disabled) return;
        const max = quantity.hasAttribute('max') ? Number(quantity.max) : Infinity;
        quantity.value = String(Math.max(1, Math.min(max, (Number(quantity.value) || 1) + Number(button.dataset.fw27QuantityStep))));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    quantity?.addEventListener('input', updateQuantitySteps);
    quantity?.addEventListener('change', updateQuantitySteps);
    const dynamic = root.querySelector('[data-fw27-dynamic]');
    const price = root.querySelector('[data-fw27-price]');
    const compare = root.querySelector('[data-fw27-compare]');
    const status = root.querySelector('[data-fw27-availability]');
    const selectedOptions = () => groups.map((group) => group.querySelector('input:checked')?.value);
    const update = (variant, changeUrl = true) => {
      const error = root.querySelector('[data-product-form-error]');
      const feedback = root.querySelector('[data-product-form-status]');
      if (error) error.textContent = '';
      if (feedback) feedback.textContent = '';
      form?.classList.remove('is-added');
      const purchasable = Boolean(variant?.available && !variant?.pricePending);
      if (select) { select.disabled = !variant || Boolean(variant.pricePending); if (variant) select.value = String(variant.id); }
      if (submit) {
        submit.disabled = !purchasable;
        const label = variant?.pricePending ? root.dataset.pricePendingLabel : variant ? (variant.available ? root.dataset.addLabel : root.dataset.soldOutLabel) : root.dataset.unavailableLabel;
        const labelNode = submit.querySelector('span') || submit;
        labelNode.textContent = label;
      }
      if (buyNow) buyNow.disabled = !purchasable;
      if (dynamic) dynamic.hidden = !purchasable;
      if (price) price.textContent = variant?.pricePending ? root.dataset.pricePendingLabel : variant ? variant.price : root.dataset.unavailableLabel;
      if (compare) { compare.hidden = !variant?.compare || Boolean(variant?.pricePending); compare.textContent = variant?.compare || ''; }
      if (status) {
        status.textContent = variant?.pricePending ? root.dataset.pricePendingLabel : !variant ? root.dataset.unavailableLabel : !variant.available ? root.dataset.soldOutLabel : variant.stock > 0 ? variant.stock <= 5 && variant.deny ? root.dataset.lowStockLabel.replace('__COUNT__', String(variant.stock)) : root.dataset.inStockLabel : root.dataset.availableLabel;
      }
      if (quantity) {
        const limited = variant?.deny && variant.stock !== null && variant.stock > 0;
        if (limited) { quantity.max = String(variant.stock); if (Number(quantity.value) > variant.stock) quantity.value = String(variant.stock); }
        else quantity.removeAttribute('max');
      }
      updateQuantitySteps();
      const options = selectedOptions();
      groups.forEach((group, index) => group.querySelectorAll('input').forEach((input) => {
        const available = variants.some((candidate) => candidate.available && !candidate.pricePending && candidate.options.every((value, position) => value === (position === index ? input.value : options[position])));
        input.dataset.unavailable = String(!available);
        const text = available ? input.value : `${input.value} — ${root.dataset.optionUnavailableLabel}`;
        input.setAttribute('aria-label', text);
      }));
      if (changeUrl && variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
        if (variant.media) activate(`media-${variant.media}`);
      }
    };
    groups.forEach((group) => group.addEventListener('change', () => {
      const options = selectedOptions();
      update(variants.find((candidate) => candidate.options.every((option, index) => option === options[index])));
    }));
    select?.addEventListener('change', () => {
      const variant = variants.find((candidate) => String(candidate.id) === select.value);
      if (variant) groups.forEach((group, index) => group.querySelectorAll('input').forEach((input) => { input.checked = input.value === variant.options[index]; }));
      update(variant);
    });
    form?.addEventListener('submit', (event) => {
      form.classList.remove('is-added');
      form.dataset.fw27BuyNow = String(Boolean(event.submitter?.matches('[data-fw27-buy-now]')));
      if (!select || select.disabled || submit?.disabled) event.preventDefault();
    });
    form?.addEventListener('sidhita:product-form-restored', () => {
      const variant = variants.find((candidate) => String(candidate.id) === select?.value);
      if (submit) submit.disabled = !variant?.available || Boolean(variant?.pricePending);
      updateQuantitySteps();
      const hasError = Boolean(root.querySelector('[data-product-form-error]')?.textContent.trim());
      const hasFeedback = Boolean(root.querySelector('[data-product-form-status]')?.textContent.trim());
      form.classList.toggle('is-added', !hasError && hasFeedback);
      const continueToBag = form.dataset.fw27BuyNow === 'true' && !hasError && hasFeedback;
      delete form.dataset.fw27BuyNow;
      if (continueToBag) window.setTimeout(() => window.location.assign(form.dataset.cartUrl || '/cart'), motionAllowed() ? 820 : 0);
    });
    const initialVariant = variants.find((candidate) => String(candidate.id) === select?.value);
    if (initialVariant) groups.forEach((group, index) => group.querySelectorAll('input').forEach((input) => { input.checked = input.value === initialVariant.options[index]; }));
    root.querySelector('[data-fw27-options]')?.removeAttribute('hidden');
    root.classList.add('is-ready');
    update(initialVariant, false);
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-fw27-product]')) initialise(scope);
    scope.querySelectorAll('[data-fw27-product]').forEach(initialise);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
